import dayjs from "dayjs";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";

import { fetchAPI } from "@utils/https/fetchAPI";

import { BlockItem } from "./BlockItem";
import { WidgetItem } from "./WidgetItem";

const Container = styled.div`
  width: 100%;
  height: 100%;
  z-index: 20000;
  position: absolute;
`;

const AdsLayout = styled.div`
  position: relative;
  width: ${({ width = "600" }) => width}px;
  height: ${({ height = "600" }) => height}px;
  box-sizing: border-box;
`;

const generatePlaylist = (campaign) => {
  const now = dayjs();
  const [sh, sm, ss] = campaign.start_time.split(":").map(Number);
  const [eh, em, es] = campaign.end_time.split(":").map(Number);
  const campaignStart = now.hour(sh).minute(sm).second(ss);
  const campaignEnd = now.hour(eh).minute(em).second(es);

  return campaign.importantCampaignBlocks.map((block) => {
    const queue = [];
    let currentTime = campaignStart.clone();

    const medias = (block.importantCampaignBlockMedias || []).filter(
      (m) =>
        m.is_use_media_in_project &&
        typeof m.duration === "number" &&
        m.duration > 0 &&
        typeof m.repeat === "number" &&
        m.repeat > 0
    );

    let mediaIndex = 0;
    let safetyCounter = 0;

    while (currentTime.isBefore(campaignEnd) && medias.length > 0) {
      if (safetyCounter++ > 10000) break; // กัน loop ค้าง

      const media = medias[mediaIndex % medias.length];
      const durationSec = media.duration;
      const repeat = media.repeat;

      for (let i = 0; i < repeat; i++) {
        const endTime = currentTime.add(durationSec, "second");
        if (endTime.isAfter(campaignEnd)) break;

        queue.push({
          media_id: media.media_id,
          type: media.type,
          attribute: media.attribute || null,
          start_at: currentTime.format("HH:mm:ss"),
          end_at: endTime.format("HH:mm:ss"),
        });

        currentTime = endTime;
      }

      mediaIndex++;
    }

    return {
      ...block,
      queue,
    };
  });
};

export const RenderImportantComponent = () => {
  const params = useParams();
  const importantCampaignId = _.get(params, ["id"]);
  const [isReady, setIsReady] = useState(false);
  const [campaign, setCampaign] = useState([]);
  const [widgets, setWidgets] = useState([]);
  const [isTimeInRange, setIsTimeInRange] = useState(false);
  const [playlist, setPlaylist] = useState(null);

  const initData = async () => {
    const resp = await fetchAPI({
      method: "post",
      path: "/api/v2/get-important-campaigns-by-serial",
      isAuth: true,
      data: { id: importantCampaignId },
    });
    const responseResult = _.get(resp, ["result"]);

    const widgets = _.get(responseResult, ["importantCampaignWidgets"]);
    setWidgets(widgets);
    const playlistQueue = generatePlaylist(_.get(responseResult, ["playlist"]));
    setCampaign(_.get(responseResult, ["playlist"]));
    console.log("playlistQueue :>> ", playlistQueue);
    setPlaylist(playlistQueue);
    setIsReady(true);
    // setCurrentCampaign(importantCampaigns);
  };

  useEffect(() => {
    initData();
  }, []);

  const checkTimeInRange = () => {
    console.log("campaign :>> ", campaign);
    const start = _.get(campaign, "start_time"); // ex: "00:09:00"
    const end = _.get(campaign, "end_time"); // ex: "00:09:30"

    if (!start || !end) {
      console.log("❌ ไม่พบ start_time หรือ end_time");
      return false;
    }

    const now = dayjs();
    const today = now.format("YYYY-MM-DD"); // ป้องกันไม่ให้ dayjs เข้าใจผิดว่าเป็นวันที่ต่างกัน

    const startTime = dayjs(`${today}T${start}`);
    const endTime = dayjs(`${today}T${end}`);

    const inRange = now.isAfter(startTime) && now.isBefore(endTime);

    console.log(`🕒 ตอนนี้: ${now.format("HH:mm:ss")}`);
    // console.log(`🔓 อยู่ในช่วงเวลา? → ${inRange}`);
    // console.log(
    //   `⏱ start: ${startTime.format("HH:mm:ss")}, end: ${endTime.format(
    //     "HH:mm:ss"
    //   )}`
    // );

    return inRange;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const inRange = checkTimeInRange();
      setIsTimeInRange(inRange);
    }, 1000);

    return () => clearInterval(interval);
  }, [campaign]);

  return (
    <>
      <Container>
        {isReady && isTimeInRange ? (
          <AdsLayout
            width={_.get(campaign, ["width"])}
            height={_.get(campaign, ["height"])}
          >
            {!_.isEmpty(widgets) &&
              _.chain(widgets)
                .map((item, index) => {
                  return <WidgetItem key={index} widget={item} index={index} />;
                })
                .value()}

            {!_.isEmpty(playlist) &&
              _.map(playlist, (item, index) => {
                return <BlockItem key={index} item={item} />;
              })}
          </AdsLayout>
        ) : null}
      </Container>
    </>
  );
};
